import styled from 'styled-components'

const FilterSortByStyle = styled.div.attrs()`
	position: absolute;
	top: 0;
	right: var(--sp4x);
	z-index: 11;

    &.draftDebates {
        opacity:0;
    }

    .selected {
                &:after {
                    content: '';
                    position: absolute;
                    top:0;
                    left:100%;
                    width: var(--spSize);
                    height: var(--spSize);
                    border-radius: 50%;
                    background-color: var(--red);
                    border:2px solid var(--white);
                    box-sizing: content-box;
                }
        }
    }
	.filter-item {
		&:last-child {
			margin-left: var(--sp4x);

			@media screen and (max-width: 1390px) {
				margin-left: var(--sp1x);
			}
		}

		i {
			margin-right: var(--spSize);
			position: relative;

			&:before {
				font-size: var(--sp3x);
			}

			&:not(.op-filter2).active{

				&:after {
					content: '';
					position: absolute;
					top:0;
					right: 0;
					width: var(--spSize);
					height: var(--spSize);
					border-radius: 50%;
					background-color: var(--red);
					border:2px solid var(--white);
					box-sizing: content-box;
				}
            }
		}

		.sort-by-popup {
			padding: var(--sp4x);
			background-color: var(--white);
			border-radius: 15px;
			position: absolute;
			top: calc(100% + var(--sp1-5x));
			box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.1);
			opacity: 0;
			transition: 0.3s;
			pointer-events: none;

			&.active {
				pointer-events: all;
				opacity: 1;
			}

			.comp-title {
				&:nth-child(2) {
					margin: var(--sp2x) 0;
				}
			}
		}

		.filter-block {
			width:var(--sp72x);
			padding: var(--sp4x);
			background-color: var(--white);
			border-radius: 15px;
			position: absolute;
			top: calc(100% + var(--sp1-5x));
			right: 0;
			box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.1);
			opacity: 0;
			transition: 0.3s;
			pointer-events: none;

			&.active {
				pointer-events: all;
				opacity: 1;
			}
			.in-filter {
				margin-bottom:0;
			}

			.buttons-block {
				.first {
					margin-right: var(--sp2x);
				}
			}
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSize})  {
		right: 0;
		
		.filter-item {
			.filter-block {
				width: var(--sp60x);
			}
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.MobileSize}) {
		right: 0;
		
		.filter-item {
			.sort-by-popup {
				right: 0;
				padding: var(--sp3x);
			}

			.filter-block {
				width: calc(100vw - var(--sp4x));
				padding: var(--sp3x);
			}
		}
	}
`

export default FilterSortByStyle
